import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";

/**
 * @param {{title: import("react").ReactNode, subtitle?: import("react").ReactNode, trust?: import("react").ReactNode, landingcontent?: import("react").ReactNode, calculator: import("react").ReactNode, floating?: import("react").ReactNode, id?: string}} props
 */
export default function LandingHeader({
  title,
  subtitle,
  trust,
  landingcontent,
  calculator,
  floating,
  id,
}) {
  return (
    <Container className="hero mx-md-auto">
      {/* mx-0: Bootstrap's .row always pulls itself wider than its parent by
          half the gutter, expecting the parent's own padding (normally tied
          to the same --bs-gutter-x) to absorb the overhang. .hero uses
          hardcoded px padding instead (20px desktop, 0px on mobile) that's
          smaller than the g-4/g-lg-5 gutter's pull-out at several
          breakpoints, so the row poked past .hero's edges — worst on mobile,
          where .hero's padding drops to 0. mx-0 cancels the row's own
          negative margin while g-4/g-lg-5 still add gutter padding inside
          each Col, so the columns keep their gap without the row bleeding
          past its container. */}
      <Row className="align-items-start g-4 g-lg-5 mx-0">
        <Col xs={12} md={7} className="order-2 order-md-1">
          <h1 className="title">{title}</h1>

          {subtitle && <p className="subtitle">{subtitle}</p>}

          {trust && <div className="hero-trust">{trust}</div>}

          {landingcontent}
        </Col>

        <Col
          id={id}
          xs={12}
          md={5}
          className="order-1 order-md-2 position-relative"
        >
          {floating && <div className="hero-float-card">{floating}</div>}

          {calculator}
        </Col>
      </Row>
    </Container>
  );
}
